import { Injectable } from '@angular/core';

import { Resolve } from '@angular/router';
import {Observable} from 'rxjs';
import {ActivationRequest, ApiService} from '../api/api.service';

@Injectable()
export class RequestActivationResolver implements Resolve<Observable<ActivationRequest>> {

  constructor(private api: ApiService) {}

  resolve() {
    return this.api.getActivtionRequests();
  }
}
